import TemplateLoadStatus from '@/components/Users/Teamplate/TemplateLoadStatus.vue'
export default {
    components: { TemplateLoadStatus },
    data() { return { templateDetailLoading: false, templateDetailError: '', templateRetry: null, templateRequestVersion: 0, templateDisposed: false } },
    computed: {
        templateCatalogue() { return this.$store.state.mytemplateTxt.myTemplate }
    },
    mounted() {
        if (this.isComponentModalActive === true || this.isShowing === true ||
            (this.isComponentModalActive === undefined && this.isShowing === undefined)) this.ensureTemplateList()
    },
    beforeDestroy() { this.templateDisposed = true; this.templateRequestVersion++ },
    watch: {
        isComponentModalActive(value) { this.templateRequestVersion++; this.templateDetailLoading = false; this.templateDetailError = ""; this.templateRetry = null; if (value) this.ensureTemplateList() },
        isShowing(value) { this.templateRequestVersion++; this.templateDetailLoading = false; this.templateDetailError = ""; this.templateRetry = null; if (value) this.ensureTemplateList() },
        dataTemplateSelected(value) { this.prefetchTemplate(value) },
        dataTemplateSelectedCt(value) { this.prefetchTemplate(value) },
        dataTemplateSelectedPrepare(value) { this.prefetchTemplate(value) }
    },
    methods: {
        async prefetchTemplate(id) {
            const version = ++this.templateRequestVersion
            this.templateDetailError = ''
            this.templateRetry = null
            this.templateDetailLoading = false
            if (id == null) return
            this.templateDetailLoading = true
            this.templateRetry = () => this.prefetchTemplate(id)
            try {
                await this.$store.dispatch('mytemplateTxt/ensureDetail', id)
                if (version === this.templateRequestVersion) this.templateRetry = null
            } catch (error) {
                if (!this.templateDisposed && version === this.templateRequestVersion) this.templateDetailError = 'โหลดเนื้อหา template ไม่สำเร็จ'
            } finally { if (version === this.templateRequestVersion) this.templateDetailLoading = false }
        },
        ensureTemplateList() { return this.$store.dispatch('mytemplateTxt/ensureList').catch(() => null) },
        retryTemplateDetail() { if (this.templateRetry) this.templateRetry() },
        async insertCachedTemplate(editorTarget = 'editorDat_prepare') {
            if (typeof editorTarget !== 'string') editorTarget = 'editorDat_prepare'
            const field = this.dataTemplateSelected !== undefined ? 'dataTemplateSelected' :
                (editorTarget === 'editorDat_ct' ? 'dataTemplateSelectedCt' : 'dataTemplateSelectedPrepare')
            const id = this[field]
            if (id == null) { this.$buefy.toast.open({ message: 'Please select a template', type: 'is-warning' }); return }
            if (this.templateDetailLoading) return
            const requestVersion = ++this.templateRequestVersion
            const epoch = this.$store.state.mytemplateTxt.epoch
            const token = localStorage.getItem('access_token')
            const quill = this.$refs[editorTarget] && this.$refs[editorTarget].quill
            if (!quill) return
            const original = JSON.stringify(quill.getContents())
            const selection = quill.getSelection() || { index: Math.max(0, quill.getLength() - 1) }
            this.templateDetailLoading = true
            this.templateDetailError = ''
            this.templateRetry = () => this.insertCachedTemplate(editorTarget)
            try {
                const data = await this.$store.dispatch('mytemplateTxt/ensureDetail', id)
                if (this.templateDisposed || requestVersion !== this.templateRequestVersion || this[field] !== id ||
                    epoch !== this.$store.state.mytemplateTxt.epoch || token !== localStorage.getItem('access_token')) return
                if (original !== JSON.stringify(quill.getContents())) {
                    this.templateDetailError = 'ข้อความมีการเปลี่ยนระหว่างโหลด กรุณากดลองใหม่เพื่อนำ template มาใช้'
                    return
                }
                const before = quill.getLength()
                quill.clipboard.dangerouslyPasteHTML(selection.index, data.content_html || '')
                quill.setSelection(selection.index + Math.max(0, quill.getLength() - before))
                this.templateRetry = null
            } catch (error) {
                if (!this.templateDisposed && requestVersion === this.templateRequestVersion) this.templateDetailError = 'โหลดเนื้อหา template ไม่สำเร็จ'
            } finally { if (requestVersion === this.templateRequestVersion) this.templateDetailLoading = false }
        }
    }
}
